

















import { Component, Prop } from 'vue-property-decorator';
import { MenuDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import Vue from 'vue';

@Component({
  components: {CmsLink},
})
export default class MobileHeaderCmsMenu extends Vue {
  @Prop({required: true})
  public readonly model!: MenuDto;

  public close(): void {
    this.$emit('close');
  }

  public back(): void {
    this.$emit('back');
  }
}
